export default __webpack_public_path__ + "static/media/24_7 market monitoring.8b391fc0.png";